<template lang="pug">
  svg(
    @mouseenter="isHover = true"
    @mouseleave="isHover = false"
    :class="iconClass",
    :style="iconStyle"
  )
    use(xmlns:xlink="http://www.w3.org/1999/xlink", :xlink:href="iconName")
</template>

<script>
  export default {
    name: 'Icon',
    props: {
      name: String,
      hoverName: String,
      size: {
        type: String,
        default: '24px',
      },
      mobileSize: String,
      width: String,
      height: String,
      fill: String,
      stroke: String,
      rotate180: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isHover: {
          type: Boolean,
          default: false,
        },
      };
    },
    computed: {
      iconClass() {
        const iconClass = { icon: true };

        iconClass[`icon--${this.name}`] = true;

        return iconClass;
      },
      iconStyle() {
        return {
          height: this.height || (this.isMobile && this.mobileSize ? this.mobileSize : this.size),
          width: this.width || (this.isMobile && this.mobileSize ? this.mobileSize : this.size),
          fill: this.fill || 'currentColor',
          ...(this.stroke && { stroke: this.stroke }),
          ...(this.rotate180 && { transform: `rotate(${this.rotate180 ? 180 : 0}deg)` }),
        };
      },
      iconName() {
        return this.isHover === true && this.hoverName ? `#${this.hoverName}` : `#${this.name}`;
      },
      isMobile() {
        return ['mobile'].includes(this.$mq);
      },
    },
  };
</script>
